// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusChip_root_30wN7"};